import $ from "jquery";
import { gsap } from "gsap";







export const initAnimation = function() {

   if ($('.home-intro__banners').length > 0 ) {

      var tl = gsap.timeline({repeat:-1});
      tl.from(".slide-image-1", {opacity:0, duration:0.5})
      tl.to(".slide-image-1", {opacity:0, duration:0.5, delay:5})
      tl.from(".slide-image-2", {opacity:0, duration:0.5})
      tl.to(".slide-image-2", {opacity:0, duration:0.5, delay:5})
      tl.from(".slide-image-3", {opacity:0, duration:0.5})
      tl.to(".slide-image-3", {opacity:0, duration:0.5, delay:5})
      tl.from(".slide-image-4", {opacity:0, duration:0.5})
      tl.to(".slide-image-4", {opacity:0, duration:0.5, delay:5})
   }
};